// extracted by mini-css-extract-plugin
module.exports = {"countdownSimple":"countdownSimple_apxy9","bold":"bold_4s51q"};